import { makeStyles } from "@fluentui/react-components";

export const useM365PulseFormChildrenWrapperStyles = makeStyles({
    root: {
        height: "100%"
    }
});
